import { render, staticRenderFns } from "./details.vue?vue&type=template&id=b5c2af10&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&id=b5c2af10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2af10",
  null
  
)

export default component.exports